<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="clearfix">
      <h3 class="m-v-0 pull-left">成果申报</h3>
      <a class="pull-left link-success m-t-2 m-l-20" @click="visible = true">
        <icon name="question-circle"></icon>
        查看批量导入说明
      </a>
    </div>
    <el-row :gutter="20" class="m-b-10">
      <el-col :span="12" v-for="type in types" :key="type.id">
        <div class="template-item clearfix">
          <div class="title">{{type.name}}</div>
          <div class="tools">
            <router-link :to="$location.achievement_edit({type: type.id})"
                         class="link-success m-r-40">
              <icon name="plus"></icon>
              单项申报
            </router-link>
            <a :href="type.template_url" class="link-success">
              <icon name="download"></icon>
              下载模板
            </a>
            <a class="link-success">
              <select-file accept=".xls,.xlsx" @change="selectFile($event, type)"
                           :disabled="submit_loading>0" v-loading="submit_loading>0">
                <icon name="upload"></icon>
                选择文件导入
              </select-file>
            </a>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="pull-right" style="position: relative; z-index: 1;">
      <el-input placeholder="搜索成果" class="max-width-200 w-a"
                suffix-icon="el-icon-search" v-model="search"></el-input>
    </div>
    <el-tabs v-model="active_index">
      <el-tab-pane v-for="(type, index) in types" :key="index"
                   :label="type.name+' ('+type.achievements.length+')'" :name="index+''">
      </el-tab-pane>
    </el-tabs>
    <el-table :data="page" border>
      <el-table-column v-for="col in active_type.form" :label="col.name" :prop="col.prop" :key="col.prop"
                       v-if="col.type !== 'file'">
        <template slot-scope="scope">
          <span v-if="col.type === 'select' && col.multiple">{{scope.row[col.prop].join('、')}}</span>
          <span v-else-if="col.filterable"
                v-html="$highlight(scope.row[col.prop], scope.row.$$pinyin[col.prop])"></span>
          <span v-else>{{scope.row[col.prop]}}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">
          <div :class="['text-' + scope.row.$$status.color]">{{scope.row.$$status.name}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" class-name="no-padding">
        <template slot-scope="scope">
          <router-link
            :to="$location.achievement_view({type: active_type.id, achievement_uid: scope.row.uid})"
            class="el-button el-button--primary el-button--mini">查看
          </router-link>
          <el-button v-if="canModify(scope.row)" type="danger" size="mini"
                     @click="deleteAchievement(scope.row)" :disabled="submit_loading>0">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filtered.length>pageInfo.page" :total="filtered.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
    <TemplateGuideDialog :visible.sync="visible" :types="types"></TemplateGuideDialog>
  </div>
</template>

<script>
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'

import * as Achievement from 'api/achievement'
import { toJSON } from 'utils/lang'
import page from 'utils/page'

import { BATCH_ACHIEVEMENT } from 'constants/storage_keys'

import TemplateGuideDialog from './TemplateGuideDialog.vue'

export default {
  components: {TemplateGuideDialog},
  data () {
    return {
      types: null,
      ready: false,
      active_index: '0',
      submit_loading: 0,
      visible: false,
      search: '',
      pageInfo: {page: 10, current: 1},
    }
  },
  computed: {
    active_type () {
      return this.types[this.active_index]
    },
    active_list () {
      return this.active_type.achievements
    },
    filtered () {
      return this.$search(this.active_list, this.search, this.active_type.searchFields)
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [list, types, status] = await Promise.all([
          Achievement.list(),
          Achievement.types(),
          Achievement.status(),
        ])
        let group = groupBy(list, 'type')
        let status_map = keyBy(status, 'id')
        types.forEach(type => {
          type.achievements = group[type.id] || []
          type.searchFields = type.form.filter(item => item.filterable).map(item => item.prop)
        })
        list.forEach(item => item.$$status = status_map[item.status])
        this.active_index = '0'
        if (this.$query.type) {
          let idx = types.findIndex(type => type.id === +this.$query.type)
          if (idx > -1) this.active_index = idx + ''
        }
        this.types = types
        this.ready = true
      })
    },
    selectFile (files, type) {
      this.$guard(this, 'submit_loading')(async () => {
        let data = await Achievement.upload({file: files[0], type: type.id})
        if (!data || !data.length) {
          this.$message('您上传的文件不包含成果信息，请检查')
          return
        }
        data.forEach(item => item.type = type.id)
        sessionStorage.setItem(BATCH_ACHIEVEMENT, toJSON(data))
        this.$router.push(this.$location.achievement_batch_edit())
      })
    },
    async deleteAchievement (achievement) {
      if (this.submit_loading) return
      if (!await this.$dangerConfirm('您确定要删除该成果吗？')) return
      this.$guard(this, 'submit_loading')(async () => {
        await Achievement.remove({data: [{uid: achievement.uid}]})
        let list = this.active_list
        let idx = list.indexOf(achievement)
        this.$message.success('删除成功')
        if (idx > -1) list.splice(idx, 1)
      })
    },
    canModify (achievement) {
      return Achievement.can_modify(achievement)
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () {
      if (!this.dontReload) this.init()
    },
    active_index (newVal) {
      this.pageInfo.current = 1
      this.dontReload = true
      let query = this.$mergeQuery({type: this.types[newVal].id})
      this.$router.replace({query: query})
      setTimeout(() => this.dontReload = false, 0)
    },
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";

.template-item {
  background-color: $color-block-background;
  padding: 20px;
  margin: 10px 0;
  $color: mix($color-border, white, 20%);
  box-shadow: 1px 1px 5px -1px $color, -1px -1px 5px -1px $color;
  border: 1px solid mix($color-border, white, 20%);
  .title {
    color: black;
    float: left;
  }
  .tools {
    float: right;
    a {
      margin-left: 10px;
      &:first-child {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/AchievementList.vue